import React from 'react';
import { toast as toastify, ToastOptions } from 'react-toastify';
import Icon from '../components/common/Icon';

export const toast = {
  success: (message: string, options?: ToastOptions) => {
    return toastify.success(message, {
      icon: <Icon name="snackbarSuccess" />,
      ...options,
    });
  },

  error: (message: string, options?: ToastOptions) => {
    return toastify.error(message, {
      icon: <Icon name="snackbarError" />,
      ...options,
    });
  },

  warning: (message: string, options?: ToastOptions) => {
    return toastify.warning(message, {
      icon: <Icon name="snackbarWarning" />,
      ...options,
    });
  },

  info: (message: string, options?: ToastOptions) => {
    return toastify.info(message, {
      icon: <Icon name="snackbarInfo" />,
      ...options,
    });
  },

  dismiss: toastify.dismiss,
  isActive: toastify.isActive,
  update: toastify.update,
};
